import React, { useEffect, useState } from "react";
import ShowTable from "./showTable";
import { getRquest } from "../../api";
function LightsCameraBannedTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);


  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getRquest(
        "arts?populate=*&pagination[pageSize]=500"
      );
      // Extracting and transforming data to a flat structure
      const transformedData = response?.data.map((item,index) => {
        const { attributes } = item;
     try {
      return {
        Sno:index+1,
        art_name: attributes.art_name,
        reported_date_of_block: attributes.reported_date_of_block,
        source: attributes.Source,
        description: attributes.Description,
        whether_edits_made: attributes.whether_edits_made,
        current_status: attributes.current_status,
        image_url: attributes.image.data?.attributes.url,
        image_name: attributes.image.data?.attributes.name,
        genre: attributes.genres.data[0]?.attributes.name || "",
        initiator: attributes.initiators.data[0].attributes.name || "",
        language: attributes.languages.data[0].attributes.name || "",
        legislation_blocked_under:
          attributes.legislation_blocked_unders.data[0]?.attributes.name ||
          "",
        reason: attributes.reasons.data[0].attributes.name || "",
        section_or_rule:
          attributes.section_or_rules.data[0].attributes.section_name || "",
        type: attributes.types.data[0].attributes.type || "",
      };
     } catch (error) {
      console.log(error);
     }

      });
      setData(transformedData);
      console.log(transformedData, "transformedData");
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Error fetching data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: (row) => row.Sno,
      minWidth: '50px',
      center:true,
    },
    {
      name: "Art name",
      selector: (row) => row.art_name,
      minWidth: '150px',
    },
    {
      name: "Reported Date of Block",
      selector: (row) => row.reported_date_of_block,
      minWidth: '200px',
      wrap:true,
      center:true,
    },
    {
      name: "Source",
      selector: (row) => {
        return <a href={row.source} target="_blank">{row.source}</a>
      },
      minWidth: '250px',
      wrap:true,
    },
     {
      name: "Description",
      selector: (row) => row.description,
      minWidth: '550px',
      wrap:true,
      center:true,
      style:{
        marginBottom:"6px"
      }

    },
    {
      name: "Whether Edits Made",
      selector: (row) => row.whether_edits_made,
      minWidth: '180px',
      wrap:true,
      center:true,
    },
    {
      name: "Current Status",
      selector: (row) => row.current_status,
      minWidth: '160px',
      wrap:true,
      center:true,

    },
    {
      name: "Image Url",
      selector: (row) => row.image_url,
      minWidth: '170px',
      wrap:true,
    },

    {
      name: "Image Name",
      selector: (row) => row.image_name,
      minWidth: '250px',
      wrap:true,
    },
    {
      name: "Genre",
      selector: (row) => row.genre,
      minWidth: '300px',
      wrap:true,
      center:true,
    },
    {
      name: "Initiator",
      selector: (row) => row.initiator,
      minWidth: '250px',
      wrap:true,
      center:true,
    },
    {
      name: "Language",
      selector: (row) => row.language,
      minWidth: '100px',
      wrap:true,
      center:true,
    },

    {
      name: "Legislation Blocked Under",
      selector: (row) => row.legislation_blocked_under,
      minWidth: '300px',
      wrap:true,
    },
    {
      name: "reason",
      selector: (row) => row.reason,
      minWidth: '250px',
      wrap:true,
      center:true,

    },
    {
      name: "Section or Rule",
      selector: (row) => row.section_or_rule,
      minWidth: '250px',
      wrap:true,
      center:true,
      
    },
    {
      name: "Type",
      selector: (row) => row.type,
      minWidth: '250px',
      wrap:true,
      center:true,
    },

  ];

  return (
    <ShowTable
     columns={columns}
     Data={data}
     title={"Lights Camera Banned Data"}
    />
  );
}

export default LightsCameraBannedTable;
